import { createAction } from '@reduxjs/toolkit';
import { translatorSlice } from './translatorSlice.ts';

export const userSpeechTranscribed = createAction<{ transcriptions: { language: string, text: string }[] }>(
  'TRANSLATOR/userSpeechTranscribed'
);

export const TranslatorActions = {
  ...translatorSlice.actions,
  userSpeechTranscribed
};